var map = {
	"./administration/administration.en.json": "./src/app/shared/pipes/json/administration/administration.en.json",
	"./administration/administration.it.json": "./src/app/shared/pipes/json/administration/administration.it.json",
	"./authority/authority-acceptance-modal.en.json": "./src/app/shared/pipes/json/authority/authority-acceptance-modal.en.json",
	"./authority/authority-acceptance-modal.it.json": "./src/app/shared/pipes/json/authority/authority-acceptance-modal.it.json",
	"./authority/authority.en.json": "./src/app/shared/pipes/json/authority/authority.en.json",
	"./authority/authority.it.json": "./src/app/shared/pipes/json/authority/authority.it.json",
	"./booking-calendar/booking-calendar.en.json": "./src/app/shared/pipes/json/booking-calendar/booking-calendar.en.json",
	"./booking-calendar/booking-calendar.it.json": "./src/app/shared/pipes/json/booking-calendar/booking-calendar.it.json",
	"./bookings/bookings.en.json": "./src/app/shared/pipes/json/bookings/bookings.en.json",
	"./bookings/bookings.it.json": "./src/app/shared/pipes/json/bookings/bookings.it.json",
	"./breadcrumbs/link_items/link_items.en.json": "./src/app/shared/pipes/json/breadcrumbs/link_items/link_items.en.json",
	"./breadcrumbs/link_items/link_items.it.json": "./src/app/shared/pipes/json/breadcrumbs/link_items/link_items.it.json",
	"./breadcrumbs/titles/titles.en.json": "./src/app/shared/pipes/json/breadcrumbs/titles/titles.en.json",
	"./breadcrumbs/titles/titles.it.json": "./src/app/shared/pipes/json/breadcrumbs/titles/titles.it.json",
	"./cargos/cargos.en.json": "./src/app/shared/pipes/json/cargos/cargos.en.json",
	"./cargos/cargos.it.json": "./src/app/shared/pipes/json/cargos/cargos.it.json",
	"./claims/claims.en.json": "./src/app/shared/pipes/json/claims/claims.en.json",
	"./claims/claims.it.json": "./src/app/shared/pipes/json/claims/claims.it.json",
	"./contract-closing/contract-closing.en.json": "./src/app/shared/pipes/json/contract-closing/contract-closing.en.json",
	"./contract-closing/contract-closing.it.json": "./src/app/shared/pipes/json/contract-closing/contract-closing.it.json",
	"./core/core.en.json": "./src/app/shared/pipes/json/core/core.en.json",
	"./core/core.it.json": "./src/app/shared/pipes/json/core/core.it.json",
	"./delivery/delivery.en.json": "./src/app/shared/pipes/json/delivery/delivery.en.json",
	"./delivery/delivery.it.json": "./src/app/shared/pipes/json/delivery/delivery.it.json",
	"./digital-sign/digital-sign.en.json": "./src/app/shared/pipes/json/digital-sign/digital-sign.en.json",
	"./digital-sign/digital-sign.it.json": "./src/app/shared/pipes/json/digital-sign/digital-sign.it.json",
	"./flotta-pool/flotta-pool.en.json": "./src/app/shared/pipes/json/flotta-pool/flotta-pool.en.json",
	"./flotta-pool/flotta-pool.it.json": "./src/app/shared/pipes/json/flotta-pool/flotta-pool.it.json",
	"./form-values/authority-form-values/authority-form-values.en.json": "./src/app/shared/pipes/json/form-values/authority-form-values/authority-form-values.en.json",
	"./form-values/authority-form-values/authority-form-values.it.json": "./src/app/shared/pipes/json/form-values/authority-form-values/authority-form-values.it.json",
	"./header/header.en.json": "./src/app/shared/pipes/json/header/header.en.json",
	"./header/header.it.json": "./src/app/shared/pipes/json/header/header.it.json",
	"./header/header.ita.json": "./src/app/shared/pipes/json/header/header.ita.json",
	"./invoicing/invoicing.en.json": "./src/app/shared/pipes/json/invoicing/invoicing.en.json",
	"./invoicing/invoicing.it.json": "./src/app/shared/pipes/json/invoicing/invoicing.it.json",
	"./logistics/logistics.en.json": "./src/app/shared/pipes/json/logistics/logistics.en.json",
	"./logistics/logistics.it.json": "./src/app/shared/pipes/json/logistics/logistics.it.json",
	"./notification-center/notification-center.en.json": "./src/app/shared/pipes/json/notification-center/notification-center.en.json",
	"./notification-center/notification-center.it.json": "./src/app/shared/pipes/json/notification-center/notification-center.it.json",
	"./profile/profile.en.json": "./src/app/shared/pipes/json/profile/profile.en.json",
	"./profile/profile.it.json": "./src/app/shared/pipes/json/profile/profile.it.json",
	"./shared/shared.en.json": "./src/app/shared/pipes/json/shared/shared.en.json",
	"./shared/shared.it.json": "./src/app/shared/pipes/json/shared/shared.it.json",
	"./tyres/tyres.en.json": "./src/app/shared/pipes/json/tyres/tyres.en.json",
	"./tyres/tyres.it.json": "./src/app/shared/pipes/json/tyres/tyres.it.json",
	"./user-change/user-change.en.json": "./src/app/shared/pipes/json/user-change/user-change.en.json",
	"./user-change/user-change.it.json": "./src/app/shared/pipes/json/user-change/user-change.it.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/shared/pipes/json sync recursive ^\\.\\/.*\\.json$";